require('./xfe-animation-css.less');

const _BASE = 'xau';
const _BASE_BTN = 'xau-btn';
const _FADE_IN = `${_BASE}-fade-in`;
const _FADE_OUT = `${_BASE}-fade-in`;
const _AOS_FADE_IN = `${_BASE}-afi`;
const _AOS_FLIP = `${_BASE}-afp`;
const _ZOOM_IN = `${_BASE}-fade-in`;
const _ZOOM_OUT = `${_BASE}-fade-in`;
const _AOS_ZOOM_IN = `${_BASE}-azi`;
const _AOS_ZOOM_OUT = `${_BASE}-azo`;
const _FAST_DELAY = 'fast-delay';
const _NORMAL_DELAY = 'normal-delay';
const _SLOW_DELAY = 'slow-delay';

/**
 * 在不调用AOS组件的基础上可以使用当前的节点作为AOS延时样式的触发开关
 * @type {string}
 */
const AOS_ROOT = 'aos-animate';

/**
 * 节点动画样式
 * @type {{BREATHING: (function(): {})}} 呼吸效果
 */
const DOM = {
  BREATHING: () => createXauCssObject(`${_BASE}-breathing`),
  SCALE: () => createXauCssObject(`${_BASE}-scale`),
  ROTATE: () => createXauCssObject(`${_BASE}-rotate`),
  SWING: () => createXauCssObject(`${_BASE}-swing`)
};

/**
 * 按钮样式
 * @type {{NORMAL: (function(): {})}}
 */
const BTN = {
  NORMAL: () => createXauCssObject(`${_BASE_BTN}-grow`),
  GROW_ROTATE: () => createXauCssObject(`${_BASE_BTN}-grow-rotate`)
};

/**
 * 渐隐动画
 * @type {{In: {DOWN: string, LEFT: string, RIGHT: string, UP: string}, OUT: {DOWN: string, LEFT: string, RIGHT: string, UP: string}}}
 */
const FADE = {
  IN: () => createXauCssObject(`${_FADE_IN}`),
  IN_UP: () => createXauCssObject(`${_FADE_IN}-up`),
  IN_DOWN: () => createXauCssObject(`${_FADE_IN}-down`),
  IN_LEFT: () => createXauCssObject(`${_FADE_IN}-left`),
  IN_RIGHT: () => createXauCssObject(`${_FADE_IN}-right`),
  OUT: () => createXauCssObject(`${_FADE_OUT}`),
  OUT_UP: () => createXauCssObject(`${_FADE_OUT}-up`),
  OUT_DOWN: () => createXauCssObject(`${_FADE_OUT}-down`),
  OUT_LEFT: () => createXauCssObject(`${_FADE_OUT}-left`),
  OUT_RIGHT: () => createXauCssObject(`${_FADE_OUT}-right`)
};

/**
 * 缩放动画
 * @type {{IN: {}, OUT: {}}}
 */
const ZOOM = {
  IN: {},
  OUT: {}
};

/**
 * 配合AOS效果实现渐隐渐现的延时效果
 * 使用demo:
 * <div className={cx(xxx, { ...xauCss.AOS_FADE.IN.XXX.FAST_DELAY.XXX() })}>
 *
 */
const AOS_FADE = {
  IN: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-${_SLOW_DELAY}-${step}`)
  },
  IN_UP: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-up-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-up-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-up-${_SLOW_DELAY}-${step}`)
  },
  IN_DOWN: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-down-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-down-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-down-${_SLOW_DELAY}-${step}`)
  },
  IN_LEFT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-left-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-left-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-left-${_SLOW_DELAY}-${step}`)
  },
  IN_RIGHT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-right-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-right-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-right-${_SLOW_DELAY}-${step}`)
  },
  IN_TOP_LEFT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-top-left-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-top-left-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-top-left-${_SLOW_DELAY}-${step}`)
  },
  IN_TOP_RIGHT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-top-right-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-top-right-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-top-right-${_SLOW_DELAY}-${step}`)
  },
  IN_BOTTOM_LEFT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-bottom-left-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-bottom-left-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-bottom-left-${_SLOW_DELAY}-${step}`)
  },
  IN_BOTTOM_RIGHT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-bottom-right-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-bottom-right-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FADE_IN}-bottom-right-${_SLOW_DELAY}-${step}`)
  },
  OUT: {}
};

/**
 * 配合AOS的缩放动画
 * @type {{IN: {SLOW_DELAY: {EIGHT: (function(): {}), FIVE: (function(): {}), SIX: (function(): {}), ONE: (function(): {}), FOUR: (function(): {}), TWO: (function(): {}), THREE: (function(): {}), SEVEN: (function(): {})}, NORMAL_DELAY: {EIGHT: (function(): {}), FIVE: (function(): {}), SIX: (function(): {}), ONE: (function(): {}), FOUR: (function(): {}), TWO: (function(): {}), THREE: (function(): {}), SEVEN: (function(): {})}, FAST_DELAY: {EIGHT: (function(): {}), FIVE: (function(): {}), SIX: (function(): {}), ONE: (function(): {}), FOUR: (function(): {}), TWO: (function(): {}), THREE: (function(): {}), SEVEN: (function(): {})}}, OUT: {SLOW_DELAY: {EIGHT: (function(): {}), FIVE: (function(): {}), SIX: (function(): {}), ONE: (function(): {}), FOUR: (function(): {}), TWO: (function(): {}), THREE: (function(): {}), SEVEN: (function(): {})}, NORMAL_DELAY: {EIGHT: (function(): {}), FIVE: (function(): {}), SIX: (function(): {}), ONE: (function(): {}), FOUR: (function(): {}), TWO: (function(): {}), THREE: (function(): {}), SEVEN: (function(): {})}, FAST_DELAY: {EIGHT: (function(): {}), FIVE: (function(): {}), SIX: (function(): {}), ONE: (function(): {}), FOUR: (function(): {}), TWO: (function(): {}), THREE: (function(): {}), SEVEN: (function(): {})}}}}
 */
const AOS_ZOOM = {
  IN: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_ZOOM_IN}-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_ZOOM_IN}-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_ZOOM_IN}-${_SLOW_DELAY}-${step}`)
  },
  OUT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_ZOOM_OUT}-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_ZOOM_OUT}-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_ZOOM_OUT}-${_SLOW_DELAY}-${step}`)
  }
};

const AOS_FLIP = {
  UP: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FLIP}-up-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FLIP}-up-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FLIP}-up-${_SLOW_DELAY}-${step}`)
  },
  DOWN: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FLIP}-down-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FLIP}-down-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FLIP}-down-${_SLOW_DELAY}-${step}`)
  },
  LEFT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FLIP}-left-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FLIP}-left-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FLIP}-left-${_SLOW_DELAY}-${step}`)
  },
  RIGHT: {
    FAST_DELAY: step => createXauCssObject(`${_AOS_FLIP}-right-${_FAST_DELAY}-${step}`),
    NORMAL_DELAY: step => createXauCssObject(`${_AOS_FLIP}-right-${_NORMAL_DELAY}-${step}`),
    SLOW_DELAY: step => createXauCssObject(`${_AOS_FLIP}-right-${_SLOW_DELAY}-${step}`)
  }
};

/**
 * 创建对应的xauCss的对象内容
 * @param data
 * @returns {{}}
 */
const createXauCssObject = data => {
  return { [data]: true };
};

const xauCss = {
  /**
   * 无AOS基础时, 使用root作为AOS延时动画的启动根节点样式
   */
  AOS_ROOT,
  /**
   * 节点动画样式
   */
  DOM,
  /**
   * 按钮动画样式
   */
  BTN,
  /**
   * 渐隐渐现动画样式
   */
  FADE,
  /**
   * 缩放动画样式
   */
  ZOOM,
  /**
   * 配合AOS的渐隐渐现动画样式
   */
  AOS_FADE,
  /**
   * 配合AOS的缩放动画样式
   */
  AOS_ZOOM,
  /**
   * 配合AOS的翻转动画样式
   */
  AOS_FLIP
};

export default xauCss;
